import { render, staticRenderFns } from "./AulaListItem.vue?vue&type=template&id=18e49194&scoped=true&"
import script from "./AulaListItem.vue?vue&type=script&lang=js&"
export * from "./AulaListItem.vue?vue&type=script&lang=js&"
import style0 from "./AulaListItem.vue?vue&type=style&index=0&id=18e49194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e49194",
  null
  
)

export default component.exports